








































import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {FloatParamDef, AnimatedParam, isAnimatedParam} from '@/params'
import type {AnyParam} from '@/params'
import VTooltip from 'v-tooltip'
import ParamAutokeyIcon from './ParamAutokeyIcon.vue'
import ParamKeyframeIcon from './ParamKeyframeIcon.vue'
import DraggableNumberInput from './DraggableNumberInput.vue'

@Component({
  name: 'NumberInput',
  components: {
    ParamAutokeyIcon, ParamKeyframeIcon, DraggableNumberInput
  }
})
export default class NumberInput extends Vue {
  @Prop() value!: number
  @Prop() param!: AnyParam

  mouseX: number | null = null
  mouseDown = false
  // Are we dragging the slider?
  draggingSlider = false

  //===== Computed properties =====
  get definition() {
    return this.param.definition as FloatParamDef // we know it must be float
  }

  get sliderMax() {
    return (this.definition.sliderMax - this.definition.sliderMin)
      / this.sliderStep
  }

  get sliderValue() {
    const max = this.sliderMax
    const value = (this.value - this.definition.sliderMin) / this.sliderStep
    if (value < 0)
      return 0
    else if (value > max)
      return max
    else
      return value
  }

  /** disable keyframing if the animated param has
      keyframes already and it's not autokey, and we're not on a
      keyframe. (Note that if there's only one keyframe and we're not
      on it and not autokey, that's OK -- we just modify that
      keyframe) */
  get disableKeyframing() {
    return isAnimatedParam(this.param) &&
      this.param.keyframeList.getNumKeyframes() >= 2 &&
      !this.param.autokey && !this.param.atKeyframe()
  }

  // The minimum visible input change
  get visibleStep() {
    return Math.pow(10, -1 * this.definition.decimalPlaces)
  }

  // The slider step size
  get sliderStep() {
    return Math.max(this.visibleStep, this.definition.step)
  }

  //===== Methods =====
  numberChanged(value: number) {
    this.$emit('input', value)
  }

  emitInputFromSlider(value: number) {
    this.$emit('input', value * this.sliderStep + this.definition.sliderMin)

  }

  toggleAutokey() {
    this.$emit('toggleAutokey')
    this.$emit('startDrag')     // not really a drag, but this selects the param.
  }

  toggleKeyframe() {
    this.$emit('toggleKeyframe')
    this.$emit('startDrag')     // not really a drag, but this selects the param.
  }

  sliderChanged(value: number) {
    // We receive a "change" event in two cases: when the user single
    // clicks on the slider, and after they finish a drag and release
    // the mouse.

    // In the first case, we want to send a "startDrag" event so the
    // resulting undo record won't merge with anything else. In the
    // second case, that would create an extra undo record (with no
    // change to the value), so we want to skip it.

    // We can distinguish these two cases by checking whether the
    // value has actually changed.

    if (value != this.sliderValue) {
      this.$emit('startDrag')
      this.emitInputFromSlider(value)
    }
  }

  sliderDragged(value: number) {
    // Ignore slider changes that were triggered programmatically.
    if (this.draggingSlider)
      this.emitInputFromSlider(value)
  }

  startSliderDrag() {
    this.$emit('startDrag')
    this.draggingSlider = true
  }

  endSliderDrag() {
    this.draggingSlider = false
  }
}
